// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"27bc02cb","250":"8317a2fa","301":"e9054b05","453":"fa130eff","591":"21d15935","697":"f7241d5d","870":"ca96d3bb","872":"c7698a49","949":"11395274","979":"0a0f14ca"}[chunkId] + ".chunk.js";
};